<template>
  <div class="users">
    <!-- <v-toolbar flat color="white" class="pa-2"> -->
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("routes.users") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="dialog = !dialog">{{
        $t("button.create")
      }}</v-btn>
    </v-toolbar>
    <!-- <v-toolbar flat color="white"> -->
    <div class="filter-adjust">
      <users-filter @queryChanged="loadUsers" />
    </div>

    <!-- </v-toolbar> -->

    <!-- Edit - Create Dialog -->
    <form-wrapper :validator="$v.editedItem">
      <v-dialog v-model="dialog" max-width="600" flat>
        <v-card>
          <v-card-title class="modal-header">
            <h2>{{ formTitle }}</h2>
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-tabs fixed-tabs slider-color="blue">
                <v-tab ripple>{{ $t("headings.main") }}</v-tab>
                <v-tab-item>
                  <v-card flat min-height="400">
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex
                            xs12
                            sm12
                            md12
                            align-center
                            justify-center
                            layout
                            text-xs-center
                            class="mb-5"
                            v-if="editedIndex > -1 || editedIndex !== -1"
                          >
                            <v-avatar
                              size="120"
                              color="grey lighten-4"
                              class="img_avatar"
                              v-if="editedItem.photo && editedIndex > -1"
                            >
                              <img :src="editedItem.photo.path" alt="avatar" />
                            </v-avatar>

                            <v-avatar
                              size="120"
                              color="grey lighten-4"
                              class="img_avatar"
                              v-if="!editedItem.photo && editedIndex > -1"
                            >
                              <img src="@/assets/imgs/user.png" alt="avatar" />
                            </v-avatar>
                            <v-icon
                              v-if="
                                editedItem.photo !== null && editedIndex > -1
                              "
                              class="pb-5 img_delete"
                              title="Dlete User Image"
                              @click="deleteUserImg(editedItem)"
                              >mdi-delete</v-icon
                            >
                          </v-flex>
                          <v-flex xs12 sm6>
                            <form-group
                              name="firstname"
                              attribute="fields.firstname"
                            >
                              <template slot-scope="{ attrs }">
                                <v-text-field
                                  v-bind="attrs"
                                  v-model="editedItem.firstname"
                                  @input="$v.editedItem.firstname.$touch()"
                                  @keyup="change = false"
                                ></v-text-field>
                              </template>
                            </form-group>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <form-group
                              name="lastname"
                              attribute="fields.lastname"
                            >
                              <template slot-scope="{ attrs }">
                                <v-text-field
                                  v-bind="attrs"
                                  v-model="editedItem.lastname"
                                  @input="$v.editedItem.lastname.$touch()"
                                  @keyup="change = false"
                                ></v-text-field>
                              </template>
                            </form-group>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <form-group name="email" attribute="fields.email">
                              <template slot-scope="{ attrs }">
                                <v-text-field
                                  v-bind="attrs"
                                  type="email"
                                  v-model="editedItem.email"
                                  @input="$v.editedItem.email.$touch()"
                                  @keyup="change = false"
                                ></v-text-field>
                              </template>
                            </form-group>
                          </v-flex>
                          <v-flex xs12 sm6 v-show="!isUpdate">
                            <form-group
                              name="password"
                              attribute="fields.password"
                            >
                              <template slot-scope="{ attrs }">
                                <v-text-field
                                  v-bind="attrs"
                                  type="password"
                                  v-model="editedItem.password"
                                  @input="$v.editedItem.password.$touch()"
                                  @keyup="change = false"
                                  autocomplete
                                ></v-text-field>
                              </template>
                            </form-group>
                          </v-flex>
                          <v-flex xs12 md12>
                            <v-layout row wrap>
                              <v-flex md6>
                                <form-group
                                  name="phone.country_code"
                                  :validator="$v.editedItem.phone.country_code"
                                  attribute="fields.country_code"
                                >
                                  <template slot-scope="{ attrs }">
                                    <v-text-field
                                      v-bind="attrs"
                                      type="tel"
                                      v-model="editedItem.phone.country_code"
                                      :label="$t('fields.country_code')"
                                      @input="
                                        $v.editedItem.phone.country_code.$touch()
                                      "
                                      @keyup="change = false"
                                    ></v-text-field>
                                  </template>
                                </form-group>
                              </v-flex>
                              <v-flex md6>
                                <form-group
                                  name="phone.phone"
                                  :validator="$v.editedItem.phone.phone"
                                  attribute="fields.phone"
                                >
                                  <template slot-scope="{ attrs }">
                                    <v-text-field
                                      v-bind="attrs"
                                      type="tel"
                                      :label="$t('fields.phone')"
                                      v-model="editedItem.phone.phone"
                                      @input="
                                        $v.editedItem.phone.phone.$touch()
                                      "
                                      @keyup="change = false"
                                    ></v-text-field>
                                  </template>
                                </form-group>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab ripple>{{ $t("headings.roles") }}</v-tab>
                <v-tab-item>
                  <v-card flat min-height="400">
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 md12>
                            <v-select
                              :label="$t('fields.roles')"
                              :items="rolesOptions"
                              v-model="editedItem.roles_ids"
                              multiple
                              chips
                              persistent-hint
                              @change="change = false"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn @click="save" class="primary mx-2" :loading="loadingState">{{
              $t("button.save")
            }}</v-btn>
            <v-btn class="secondary mx-2" text @click="dialog = false">{{
              $t("button.close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </form-wrapper>
    <!-- Edit - Create Dialog -->

    <v-data-table
      :items="items"
      :headers="headers"
      class="elevation-1"
      hide-default-footer
      :items-per-page="20"
      :loading="loadingState"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="py-1 text-center">
            <img
              width="40px"
              class="mx-auto"
              :src="getImagePath(item)"
              alt="main_photo"
              title="main photo"
            />
          </td>
          <td class="text-center">
            {{ item.firstname }}
            <span v-if="item.lastname !== null">{{ " " + item.lastname }}</span>
          </td>
          <td class="text-center">{{ item.email || "------" }}</td>
          <td class="text-center">
            {{ item.phone ? item.phone.phone : "---" }}
          </td>
          <td class="text-center">
            <v-btn
              v-if="item.member"
              color="secondary"
              class="text-capitalize"
              :to="`/new-members/list?name=${item.member && item.member.name}`"
            >
              {{ $t("table.Edit_membership") }}
            </v-btn>
            <v-btn
              v-else
              color="primary"
              class="text-capitalize"
              :to="{
                path: '/new-members/create-member',
                query: {
                  user_id: item.id,
                },
              }"
            >
              {{ $t("labels.signup_member") }}
            </v-btn>
          </td>

          <td class="toggle-spacing text-center">
            <toggle-service
              :is-edit="true"
              model-name="user"
              :model-id="item.id"
              field="blocked"
              v-model="item.blocked"
              :validate="true"
            />
          </td>
          <td class="toggle-spacing text-center">
            <v-icon color="success" v-if="item.email_verified"
              >mdi-check-circle-outline</v-icon
            >
            <v-icon color="error" v-else>mdi-close-circle</v-icon>
          </td>
          <td class="toggle-spacing text-center">
            <v-icon color="success" v-if="item.phone_verified"
              >mdi-check-circle-outline</v-icon
            >
            <v-icon color="error" v-else>mdi-close-circle</v-icon>
          </td>

          <td class="text-center">
            <v-icon small class="mr-2 edit" @click="editItem(item, index)">
              mdi-pencil
            </v-icon>
            <v-icon class="delete" small @click="deleteItem(item, index)">
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div class="text-xs-center pt-2">
      <v-pagination
        v-if="items.length > 0 && pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="10"
        @input="handlePagination"
      ></v-pagination>
    </div>

    <!-- Image Preview -->
    <global-image-preview
      :showDialog="imageOverlay"
      :imagePath="currentPreviewImage"
      @closePreview="imageOverlay = false"
    />
    <!-- Image Preview -->
  </div>
</template>
<script>
const defaultItem = {
  firstname: "",
  email: "",
  password: "",
  phone: {
    phone: "",
    country_code: "",
  },
  country_id: null,
  state_id: null,
  address: {
    text: "",
  },
};
import {
  required,
  maxLength,
  minLength,
  email,
  numeric,
} from "vuelidate/lib/validators";
import {
  createUser,
  updateUser,
  deleteUser,
  showUser,
  indexUsers,
  deleteUserImg,
} from "@/api/users";
import { indexRoles } from "@/api/roles";
import UsersFilter from "./filter.vue";
import { generateQuery } from "@/utils/helpers";
import { validPhoneNumber } from "@/utils/validate.js";
import TableHeaders from "@/helpers/TableHeaders";

export default {
  name: "users",
  components: {
    UsersFilter,
  },
  data() {
    return {
      usersHeader: [
        "firstname",
        "lastname",
        "email",
        "phone",
        "photo",
        "blocked",
      ],
      toggle: ["blocked"],
      ignores: ["photo"],
      imgsName: ["photo"],
      headers: [],
      dialog: false,
      dateMenu: false,
      items: [],
      rolesOptions: [],
      genderOptions: [
        { text: "male", value: 1 },
        { text: "female", value: 2 },
      ],
      pagination: {
        current_page: 1,
        last_page: 0,
      },
      isUpdate: false,
      change: true,
      editedIndex: -1,
      editedItem: {
        ...defaultItem,
      },
      loadingState: false,
      imgCheack: false,
      ROLES_TAB: 1,
      ADDRESS_TAB: 2,
      imageOverlay: false,
      currentPreviewImage: "",
      countiresItems: [],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
      this.change = true;
      this.loadingState = false;
      this.$v.$reset();
      this.$store.dispatch("ClearServerErrors"); // clear serverErorrs
    },
  },
  filters: {
    filterName(val) {
      // start with 0 and end with string length - what length i want to be
      return val.substring(0, val.length - 5) + "...";
    },
  },
  mounted() {
    indexRoles()
      .then((res) => {
        this.rolesOptions = res.data.data.map((elm) => {
          return {
            value: elm.id,
            text: elm.display_name,
          };
        });
      })
      .catch(() => {});
  },
  created() {
    let queryString = generateQuery(this.$route.query);
    this.loadUsers(queryString);
    this.createTableHeaders();
  },
  methods: {
    loadUsers(queryString) {
      this.loadingState = true;
      indexUsers(queryString)
        .then((res) => {
          this.items = res.data.data;
          this.pagination = res.data.meta;
          this.loadingState = false;
        })
        .catch(() => {
          this.loadingState = false;
        });
    },
    createTableHeaders() {
      const headersList = [
        "photo",
        "name",
        "email",
        "phone",
        "membership",
        "blocked",
        "email_verified",
        "phone_verified",
        "actions",
      ];
      this.headers = TableHeaders(headersList);
    },
    handlePagination(page) {
      this.$router.replace({ query: { ...this.$route.query, page: page } });
    },
    editItem(item, index) {
      this.dialog = true;
      this.isUpdate = true;
      this.imgCheack = true;
      this.editedIndex = index;
      this.editedItem.username = item.username;
      this.loadCurrentUser();
    },
    deleteItem(item) {
      this.popUp(this.$t("message.warning"), "warning").then((value) => {
        if (!value.dismiss) {
          deleteUser(item)
            .then(() => {
              let itemIndex = this.items.filter((el) => el.id !== item.id);
              this.items = [...itemIndex];
            })
            .catch(() => {});
        }
      });
    },
    getImagePath(item) {
      if (item.photo && item.photo.path) {
        return item.photo.path;
      } else {
        return require("@/assets/imgs/user.png");
      }
    },
    close() {
      this.dialog = false;
      this.change = true;
      this.imgCheack = false;
      this.loadingState = false;

      setTimeout(() => {
        this.$v.$reset();
        this.isUpdate = false;
        this.editedItem = Object.assign({}, defaultItem);
        this.editedIndex = -1;
      }, 100);
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loadingState = true;
      let reqData = {
        ...this.editedItem,
        locale: "en",
      };

      if (this.editedIndex > -1) {
        // update
        const { username } = this.editedItem;
        updateUser(reqData, username)
          .then((res) => {
            const { user } = res.data;
            this.items[this.editedIndex] = user;
            this.items = [...this.items]; // important for reactevity updating
            this.loadingState = false;
            this.change = true;
            this.dialog = false;
          })
          .catch(() => {
            this.loadingState = false;
            this.change = true;
          });
      } else {
        // create
        createUser(reqData)
          .then((res) => {
            const { user } = res.data;

            this.items.push(user);
            this.loadingState = false;
            this.change = true;
            this.dialog = !this.dialog;
          })
          .catch(() => {
            this.loadingState = false;
            this.change = true;
          });
      }
      // this.close();
    },
    loadCurrentUser() {
      showUser(this.editedItem)
        .then((res) => {
          this.editedItem = this.reArrangeCurrentItem(this.editedItem, res);
        })
        .catch(() => {});
    },
    reArrangeCurrentItem(item, res) {
      const user = res.data.user;
      let temp = {
        ...user,
      };
      temp.roles_ids = temp.roles.map((elm) => elm.id);
      return temp;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    deleteUserImg(editedItem) {
      if (editedItem.photo.id) {
        this.popUp(this.$t("message.warning"), "warning").then((value) => {
          if (!value.dismiss) {
            deleteUserImg(editedItem.photo.id)
              .then(() => {
                editedItem.photo = null; // to update user img
                let queryString = generateQuery(this.$route.query);
                this.loadUsers(queryString);
              })
              .catch(() => {});
          }
        });
      }
    },
    validationsRules() {
      return {
        editedItem: {
          firstname: {
            required,
            maxLength: maxLength(15),
            minLength: minLength(3),
          },
          lastname: {
            maxLength: maxLength(15),
            minLength: minLength(3),
          },
          email: { required, email },
          password: {
            required: !this.isUpdate ? required : false,
            minLength: minLength(6),
          },
          phone: {
            phone: {
              required,
              numeric,
              maxLength: maxLength(14),
              minLength: minLength(9),
              validSaudiPhone: validPhoneNumber,
            },
            country_code: {
              required,
              numeric,
              minLength: minLength(3),
            },
          },
        },
      };
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    },
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("headings.create_user")
        : this.$t("headings.edit_user");
    },
  },
  validations() {
    if (!this.isUpdate) {
      return this.validationsRules();
    } else {
      return this.validationsRules();
    }
  },
};
</script>
